import React from 'react';
import { connect } from "react-redux";
import { Wrapper } from "./style.js";
import { Icon } from "semantic-ui-react";

const UnitList = (props) => {
    const { completed, debriefs, header } = props;
    const icon = completed  ? 'check' : 'remove';

    return (<Wrapper className={completed ? 'complete' : 'incomplete'}>
        {header && <h4><Icon name={`${icon} circle`}/>{completed ? 'Completed' : 'Not Completed'}</h4>}
        <ul>
            {debriefs.map( (d,i) => (
            <li key={i}>
                <Icon name={icon}/>{d}
            </li>
            ))}
        </ul>
    </Wrapper>)
}

export default connect(store => {
    return {
      user: store.user
    };
  })(UnitList);
  


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DebriefDashboard/components/UnitList/index.jsx